/**
 * Filename: simpleLineChart.js
 * Simple line chanrt to show simple chart
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush} from 'recharts';
import * as dataService from "../service/data-info-chart/requestsUtil";
import {COLORS, MONTHLY_PORTFOLIO, MONTHLY_RECOVERY_ACUMMULATED, voidData} from "../utils/constants";
import {GRAPH_MARGIN, WHITOUT_INFORMATION} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";
import * as formatter from "../utils/formatters";

var Loader = require('react-loader');

class AmountPorfolio extends Component {

  constructor(props) {
    super(props);
    this.state = {datas: [], loaded: false, date:this.props.date}
  }

  componentDidMount() {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.state.date
    }

    dataService.postFetch(MONTHLY_PORTFOLIO, params)
      .then((data) => {
        this.setState({datas: data, loaded: true});
      });
  }

  componentWillReceiveProps(nextProps) {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.props.date
    }

    dataService.postFetch(MONTHLY_PORTFOLIO, params)
      .then((data) => {
        this.setState({datas: data, loaded: true, date:nextProps.date});
      });
  }

  render() {
    if (this.state.datas.length > 0) {
      return (
        <Loader top={'90%'} loaded={this.state.loaded}>
          <ResponsiveContainer>
            <LineChart width={600} height={300} data={this.state.datas}
                       margin={GRAPH_MARGIN}>
              <XAxis dataKey="month"/>
              <YAxis tickFormatter={formatter.formatNumber} domain={['dataMin - 1000000', 'dataMax + 1000000']}/>
              <CartesianGrid/>
              <Tooltip formatter={formatter.formatNumberMoney}/>
              <Legend verticalAlign={"top"}/>
              <Line type="linear" name={"Rezago"} dataKey="amount" stroke={COLORS.GOAL}/>
              <Brush dataKey={"mes"} height={20}/>
            </LineChart>
          </ResponsiveContainer>
        </Loader>
      );
    } else {
      return (
        <Loader top={'90%'} loaded={this.state.loaded}>
          <ResponsiveContainer>
            <LineChart width={600} height={300} data={voidData}
                       margin={GRAPH_MARGIN}>
              <XAxis dataKey="month"/>
              <YAxis tickFormatter={formatter.formatNumber} scale={'linear'} />
              <CartesianGrid/>
              <Tooltip formatter={formatter.formatNumberMoney}/>
              <Legend verticalAlign={"top"}/>
              <Line type="linear" name={"Monto"} dataKey="amount" stroke={COLORS.GOAL}/>
              <Brush dataKey={"mes"} height={20}/>
            </LineChart>
          </ResponsiveContainer>
        </Loader>
      );
    }


  }
}

// Connect linechartdata as props to compenent
function mapStateToProps(state) {
  return {
    lineChartData: state.amountPortfolio
  }
}

export default connect(mapStateToProps)(AmountPorfolio);




// WEBPACK FOOTER //
// ./src/charts/amountPorfolio.js